import { SHOW_SPINNER } from "../../constants/Wrapper/Spinner";

export const actionShowSpinner = (payload) => ({
  type: SHOW_SPINNER,
  payload,
});
